import type { PageViewedProperties } from '../codegen/ampli'

export function getRequestOrigin(request: Request) {
  return `${request.headers.get('x-forwarded-proto') ?? 'http'}://${request.headers.get('host')}/`
}

/**
 * Pick headers from a Headers object by **inclusion** of key
 *
 * @example
 * ```ts
 * const headers = new Headers()
 * headers.set('cookie', 'test=1')
 * headers.set('x-datadog-trace-id', 'test=2')
 * pickHeaders(headers, ['cookie', 'datadog']) // { cookie: 'test=1' , 'x-datadog-trace-id': 'test=2' }
 * ```
 */
export function pickHeaders(headers: Headers, keys: string[]) {
  const pickedHeaders = new Headers()
  for (const [key, value] of headers.entries()) {
    if (keys.some((k) => key.toLowerCase().includes(k.toLowerCase()))) {
      pickedHeaders.set(key, value)
    }
  }

  return pickedHeaders
}

export const getCurrentPageType = (): PageViewedProperties['page'] => {
  if (typeof window === 'undefined') return 'home'

  const path = window.location.pathname

  if (/^\/route\/[^/]+$/.test(path)) {
    return 'route detail'
  }

  if (/^\/tokens\/[^/]+$/.test(path)) {
    // Updated regex to match /tokens/plume
    return 'token info'
  }

  return 'home'
}

export function getBaseDomain(uri: string): string {
  let hostname = uri
  try {
    hostname = new URL(uri).hostname
  } catch {}
  const parts = hostname.split('.')
  if (parts.length >= 2) {
    return parts.slice(-2).join('.')
  }
  return hostname
}
